// Pure helpers for the activity log (apps/web/src/pages/ActivityLog.tsx): Dubai days, the date filter, before → after.
/** Dubai day (yyyy-mm-dd) of a time. */
export const dubaiDay = (t: number | string | Date) => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Dubai', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(t));

export type Range = '' | 'today' | '7d' | '30d' | 'month' | 'lastmonth' | '90d';
/** The date filter as Dubai days, from and to (inclusive). */
export function rangeDays(r: Range, now = Date.now()): { from?: string; to?: string } {
  if (!r) return {};
  const today = dubaiDay(now);
  const back = (n: number) => dubaiDay(Date.parse(today + 'T12:00:00+04:00') - n * 86_400_000);
  if (r === 'today') return { from: today, to: today };
  if (r === '7d') return { from: back(6), to: today };
  if (r === '30d') return { from: back(29), to: today };
  if (r === '90d') return { from: back(89), to: today };
  const [y, m] = today.split('-').map(Number) as [number, number];
  if (r === 'month') return { from: `${y}-${String(m).padStart(2, '0')}-01`, to: today };
  const py = m === 1 ? y - 1 : y, pm = m === 1 ? 12 : m - 1;
  const last = new Date(Date.UTC(py, pm, 0)).getUTCDate();
  return { from: `${py}-${String(pm).padStart(2, '0')}-01`, to: `${py}-${String(pm).padStart(2, '0')}-${last}` };
}

const show = (v: unknown) => v == null ? '—' : typeof v === 'object' ? JSON.stringify(v) : String(v);
/** Before → after as lines: changed keys of two objects, or the two values. */
export function diffLines(before: unknown, after: unknown): [string, string, string][] {
  if (before == null && after == null) return [];
  const obj = (v: unknown): v is Record<string, unknown> => !!v && typeof v === 'object' && !Array.isArray(v);
  if (obj(before) || obj(after)) {
    const b = obj(before) ? before : {}, a = obj(after) ? after : {};
    return [...new Set([...Object.keys(b), ...Object.keys(a)])].filter(k => JSON.stringify(b[k]) !== JSON.stringify(a[k])).map(k => [k, show(b[k]), show(a[k])]);
  }
  return [['', show(before), show(after)]];
}

